





































import {Component, Prop} from "vue-property-decorator";
import BaseDialog from "@/component/Dialog/base-dialog.vue";

@Component({})
export default class DeleteDialog extends BaseDialog {

  @Prop() objName!: string | undefined

  /**
   * 确认删除需要输入的文本
   */
  @Prop({default: "确认删除"}) confirmInput!: string
  @Prop({default: false, type: Boolean}) showInput!: boolean

  private input = ''

  private get confirmInputTip() {
    return `请输入 \`${this.confirmInput}\``
  }

  protected defaultConfirmBtncfg = {
    type: 'danger',
    text: this.$translate('delete'),
    show: true,
  }

  private showConfirmInputTip = false

  async deleteClose(): Promise<void> {
    this.close();
    this.input = ''
    this.showConfirmInputTip = false
  }

  private async deleteConfirm() {
    if (this.showInput && this.input != this.confirmInput) {
      this.showConfirmInputTip = true
      return
    }
    await this.doConfirm()
    this.input = ''
  }
}
